module.exports = __webpack_public_path__ + "static/media/TrainLink-Logo.be758eaf.png";